import { render, staticRenderFns } from "./AtomPinImage.vue?vue&type=template&id=712050a9&"
import script from "./AtomPinImage.vue?vue&type=script&lang=js&"
export * from "./AtomPinImage.vue?vue&type=script&lang=js&"
import style0 from "./AtomPinImage.vue?vue&type=style&index=0&id=712050a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports